<template>
  <b-card
    no-body
    class="card-statistics"
  >
    <b-card-header>
      <b-card-title>Detalles de procesos finalizados</b-card-title>
    </b-card-header>
    <b-card-body class="statistics-body">
      <div class="row">
        <div class="col-lg-3 col-sm-6"
             v-for="item in indicators"
             :key="item.id"
        >
          <b-media no-body>
            <b-media-aside
              class="mr-2"
            >
              <b-avatar
                size="48"
                :variant="item.color"
              >
                <feather-icon
                  size="24"
                  :icon="item.icon"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <h4 class="font-weight-bolder mb-0">
                {{ item.title }}
              </h4>
              <b-card-text class="font-small-3 mb-0">
                {{ item.count }}
              </b-card-text>
            </b-media-body>
          </b-media>
        </div>
      </div>
    </b-card-body>
  </b-card>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: {
    indicators: { type: Array }
  }
};
</script>
